// Shared v-data-table custom-filter for invoice tables:
// matches internal id, invoice_code, customer name, and purpose.
export function invoiceSearchFilter(value, search, item) {
  if (search == null || search === "") return true;
  const needle = String(search).toLowerCase();
  return [
    item.id,
    item.invoice_code,
    item.customer && item.customer.customer_name,
    item.purpose,
  ].some((field) => {
    return field != null && String(field).toLowerCase().includes(needle);
  });
}

// Options for the "Sort by" selects on the Invoices page tabs.
// `value` matches both the client-side item property and the
// server-side sort_by whitelist in InvoiceController@get_paid_invoices.
export const invoiceSortOptions = [
  { text: "ID", value: "id" },
  { text: "Invoice #", value: "invoice_code" },
  { text: "Invoice Date", value: "invoice_date" },
  { text: "Total Amount", value: "total_amount" },
  { text: "Purpose", value: "purpose" },
];
